import * as z from 'zod/v4';

const EnvSchema = z.object({
	VITE_DUENDE_CLIENT_ID: z
		.string()
		.default('e22f056f-e167-4d74-b6f6-fc21cd6fb8cd'),
	VITE_DUENDE_CODE_CHALLANGE: z
		.string()
		.default('lWjl2DqcNRlEeSw9-Ea3jDq4_sFmTtXe5-GdnoKSSKA'),
	VITE_DUENDE_CODE_CHALLANGE_METHOD: z.string().default('S256'),
	VITE_DUENDE_REDIRECT_URI: z
		.url()
		.default('https://circlestaging.local:5173/account/login-callback'),
	VITE_DUENDE_REDIRECT_URI_LOGOUT: z
		.url()
		.default('https://circlestaging.local:5173/account/login-callback'),
	VITE_DUENDE_SCOPE: z
		.string()
		.default('openid offline_access verification profile'),
	VITE_DUENDE_URL: z.url().default('https://dev-accounts.astra.co.id'),
	VITE_SENTRY_DSN: z
		.string()
		.default(
			'https://af5fc015c7c1a64b65ae950631c68fe0@insightapp.astra.co.id/156'
		)
});

export type Environment = z.TypeOf<typeof EnvSchema>;

const { data, error } = EnvSchema.safeParse(import.meta.env);

if (error) {
	const errorMessage = `❌ Invalid env - ${Object.entries(z.treeifyError(error))
		.map(([key, errors]) => `${key}: ${JSON.stringify(errors, null, 2)}`)
		.join(' | ')}`;
	throw new Error(
		JSON.stringify({ errorMessage, data: import.meta.env }, null, 2)
	);
}

export const env = data;
